import { render, staticRenderFns } from "./Rollback.vue?vue&type=template&id=23471282"
import script from "./Rollback.vue?vue&type=script&lang=js"
export * from "./Rollback.vue?vue&type=script&lang=js"
import style0 from "./Rollback.vue?vue&type=style&index=0&id=23471282&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports